import { FaArrowRight, FaTrophy } from "react-icons/fa";
import { achievements, featuredAchievement } from "../data";
import SectionHeading from "./SectionHeading";

const tones = ["lilac", "peach", "pink"];

function Achievements() {
  return (
    <section className="section container" id="achievements">
      <SectionHeading title="Achievements" />

      <a
        className="feature"
        href={featuredAchievement.url}
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="feature-top">
          <span className="feature-icon">
            <FaTrophy />
          </span>
          <span className="mono">{featuredAchievement.type}</span>
        </div>
        <p>{featuredAchievement.text}</p>
        <div className="feature-foot">
          <strong>{featuredAchievement.title}</strong>
          <span>{featuredAchievement.sub}</span>
        </div>
      </a>

      <div className="rows">
        {achievements.map((item, index) => (
          <a
            className={`row row-link hover-${tones[index % tones.length]}`}
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
            key={item.title}
          >
            <span className="mono">{item.type}</span>
            <div>
              <h3>{item.title}</h3>
              <p className="row-text">{item.text}</p>
            </div>
            <span className="row-cta">
              {item.cta || "Learn more"} <FaArrowRight />
            </span>
          </a>
        ))}
      </div>
    </section>
  );
}

export default Achievements;
